import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class ClientsStateDataService {
    private clientStateMsg = new Subject<string>();
    constructor() {

    }
    /*
   * @return {Observable<string>} : siblingMsg
   */
    public getMessage(): Observable<string> {
        return this.clientStateMsg.asObservable();
    }
    /*
     * @param {string} message : siblingMsg
     */
    public updateMessage(message: string): void {
        this.clientStateMsg.next(message);
    }
}
